const CustomLabel = ({ name, className }: { name: string; className?: string }) => {
  return <div className={`text-ds-gray-800 font font-semibold ${className}`}>{name}</div>;
};

export default CustomLabel;
